import React, { useCallback, useEffect, useState } from "react";
import './external-company-registration.css';
import { useForm } from "react-hook-form";
import { IconContext } from 'react-icons';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { getCountryStateDistrict, companyRegistration, getCompanyDetails } from "../../services/login-api.js";
import PhoneInput from 'react-phone-input-2'
import { global_var } from "../../services/login-config.js";
import { Spin } from 'antd';
import externalRegistration from '../../assets/images/external_registration.png';
import cyberSquareLogo from '../../assets/images/cybersquare_logo.png';


const ExternalCompanyRegistration = () => {

    const [showPassword, setShowPassword] = useState(false);
    const [Countries, setCountry] = useState([]);
    const [states, setState] = useState([]);
    const [district, setDistrict] = useState([]);
    const [mobileNumber, setMobileNumber] = useState({ dialCode: '+91', number: '' });
    const [signupStart, setSignupStart] = useState(false)

    const form = useForm({
        defaultValues: {
          role: "teacher",
        },
      });
    const { register, handleSubmit, formState, watch, reset, setError } = form
    const { errors } = formState;

    const pswd = watch('password', '');
    const countryId = watch('country', '');

    const roleOptions = [
        { id: 'teacher', label: 'Teacher' },
        { id: 'admin', label: 'Admin' }
    ];

    const togglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const onSubmit = async (data) => {

        if(signupStart){
            return
        }

        const domainRes = await getCompanyDetails({'domainName':data.schoolDomain + global_var.domain, 'checkingForConfiguration': true});
        if(domainRes.company_obj.result === 'Exists'){
            setError("schoolDomain", {
                type: "custom",
                message: "This domain is already registered. Please use a different email.",
            });
            return
        }

        const countryObj = Countries.find(Item => Item._id === data.country)

        const formData = {
            userRole: data.role,
            fullName: data.firstName + ' ' +(data.lastName ? data.lastName : ''),
            Email: data.schoolEmail,
            password: data.password,
            companyName: data.schoolName,
            domainName: data.schoolDomain,
            fkcountryId: data.country,
            countryName: countryObj.countryName,
            fkCountryCode: countryObj.countryCode,
            registerFrom: "Web",
            parent_company_id: '562de15e3c43a07b61c29188',
            companyType: 'SC',
            userRoleId: data.role === 'admin' ? 2 : data.role === 'teacher' ? 7 : null
        };

        if(data.postalcode !== null){
            formData.postalcode = data.postalcode;
        };

        if(data.state !== ""){
            formData.fkstateId = data.state;
            formData.stateName = states.find(Item => Item._id === data.state).stateName
        };

        if(data.district !== ""){
            formData.fkdistrictId = data.district;
            formData.districtName = district.find(Item => Item._id === data.district).districtName
        };

        if(mobileNumber.number){
            formData.contactNumber = mobileNumber.number
            if(mobileNumber.dialCode){
                formData.dialCode = '+' + mobileNumber.dialCode
            }
        }

        setSignupStart(true)
        const res = await companyRegistration(formData);
        setSignupStart(false)
        if(res.data.statusCode === 200){
            reset()
            window.open('https://' + res.data.domain);
        }

    }

    const handleMobileInput = (value, data) => {
        const obj = {
            dialCode: data['dialCode']
        }
        const number = value.startsWith(data['dialCode']) ? value.slice(data['dialCode'].length) : value;
        obj['number'] = number
        setMobileNumber(obj)
    }

    const fetchCountryStateDistrict = useCallback(async (params) => {

        try {
            const response = await getCountryStateDistrict(params);
            if(response.data.statusCode === 200){
                if(params.type === 'country'){
                    setCountry(response.data.CountryStateDistrictCollection)
                }else if(params.type === 'state'){
                    setState(response.data.CountryStateDistrictCollection)
                }else if(params.type === 'district'){
                    setDistrict(response.data.CountryStateDistrictCollection)
                }
            }
        }catch(error){
            console.log(error)
        }

    },[])

    useEffect(() => {

        fetchCountryStateDistrict({'type':'country'});

        // const fetchUserInfo = async () => {
        //     const hashParams = new URLSearchParams(window.location.hash.substring(1));
        //     console.log(hashParams)
        //     if(hashParams.get('access_token')){
        //         const accessToken = hashParams.get('access_token');
          
        //         if (!accessToken) {
        //           console.error('Access token or state parameter not found');
        //           return;
        //         }
    
        //         const response = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        //             headers: {
        //                 "Authorization": `Bearer ${accessToken}`
        //             }
        //         });
        
        //         if (!response.ok) {
        //         throw new Error('Failed to fetch user information');
        //         }
        //         const userInfo = await response.json();
        //         if (userInfo.email_verified === true) {
        //             console.log(userInfo)
        //             const Email = userInfo.email
        //             console.log(Email)
        //         } else {
        //             console.error('email is not verified')
        //         }
        //     }
        // };
        // fetchUserInfo();

    }, [fetchCountryStateDistrict]);


    // const handleGoogleSign = async (event) => {

    //     // const isValid = await trigger(["role", "password", "schoolName", "schoolDomain", "country"]);
    //     // if (isValid) {
    //     // const formData = getValues();
    //     // console.log("Form is valid", formData);
    //     // } else {
    //     // console.log("Form validation failed");
    //     // }

    //     const oauthEndpoint = "https://accounts.google.com/o/oauth2/v2/auth";
    //     const redirectUri = "http://cs.test99lms.com/:3000/externalCompanyRegistration";
    //     const clientId = "189632572316-oun42fvr10aut9rukbn7pngtblsvg05o.apps.googleusercontent.com";
    //     const scope = "https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email";
    //     const responseType = "token";
    //     const stateParams = {
    //         current_url: window.location.href
    //     };
    //     const stateString = JSON.stringify(stateParams);
    //     const state = encodeURIComponent(stateString);

    //     const authUrl = `${oauthEndpoint}?client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=${encodeURIComponent(scope)}&state=${state}&prompt=select_account`; 

    //     // Redirect the user to Google OAuth consent screen
    //     window.location.href = authUrl;
    // };



    return(

        <div className='createAccount'>
            <div className='pageWrapper'>
                <header className='header'>
                    <div className='logoContainer'>
                        <img
                        loading="lazy"
                        src={cyberSquareLogo}
                        className='logo'
                        alt="Company Logo"
                        />
                    </div>
                    <button className='enquireButton'>Enquire now</button>
                </header>
                <div className='mainContent'>
                    <section className='heroSection'>
                        <div className='heroContent'>
                            <img
                            loading="lazy"
                            src={externalRegistration}
                            className='heroImage'
                            alt="Teaching professionals collaborating"
                            />
                            <h1 className='heroTitle'>
                            Illuminate Minds, Join the Teaching Revolution
                            </h1>
                        </div>
                    </section>

                    <form className='signUpContainer' onSubmit={handleSubmit(onSubmit)}>
                        <div className='formHeader'>
                            <h2 className='formTitle'>Create your Schools Account</h2>
                        </div>


                        <div className='radioGroup' role="radiogroup">
                            {roleOptions.map((option) => (
                                <div key={option.id} className='radioOption'>
                                <input
                                    type="radio"
                                    id={option.id}
                                    name='role'
                                    value={option.id}
                                    className='radioInput'
                                    {...register("role", {
                                        required: {
                                            value: true,
                                            message: "Please select a user role"
                                        }
                                    })}
                                />
                                <label htmlFor={option.id} className='radioLabel'>
                                    {option.label}
                                </label>
                                </div>
                            ))}
                        </div>
                        <div className="error-msg">{errors.role?.message}</div>

                        <div className='nameFields'>

                            <div className='input-width-53'>
                                <label className="visually-hidden">
                                    First Name
                                </label>
                                <input
                                    type='text'
                                    className='textInput'
                                    placeholder='First Name'
                                    aria-label="First Name"
                                    {...register('firstName', {
                                        required: {
                                            value: true,
                                            message: 'First name is required'
                                        },
                                        minLength: {
                                            value: 2,
                                            message: 'First name should be between 2 and 50 characters long'
                                        },
                                        maxLength:{
                                            value: 50,
                                            message: 'First name should be between 2 and 50 characters long'
                                        }
                                    })}
                                />
                            </div>

                            <div className='input-width-53'>
                                <label className="visually-hidden">
                                    Last Name
                                </label>
                                <input
                                    type='text'
                                    className='textInput'
                                    placeholder='Last Name'
                                    aria-label="Last Name"
                                    {...register('lastName', {
                                        required: {
                                            value: false,
                                            message: 'Enter your firstName to proceed'
                                        },
                                        minLength:{
                                            value: 2,
                                            message: "Last name should be between 2 and 50 characters long"
                                        },
                                        maxLength:{
                                            value: 50,
                                            message: 'Last name should be between 2 and 50 characters long'
                                        }
                                    })}
                                />
                            </div>

                        </div>
                        <div className="error-msg">{errors.firstName?.message}</div>

                        <div className='inputWrapper'>
                            <label className="visually-hidden">
                                Official School Email
                            </label>
                            <input
                                type='email'
                                className='textInput'
                                placeholder='Official School Email'
                                aria-label="Official School Email"
                                {...register('schoolEmail', {
                                    required: {
                                        value: true,
                                        message: 'Email address is required'
                                    },
                                    pattern: {
                                        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                                        message: 'Please enter a valid email address'
                                    }
                                })}
                            />
                        </div>
                        <div className="error-msg">{errors.schoolEmail?.message}</div>

                        <div className='inputWrapper' style={{ position: 'relative', width: '100%' }}>
                            <label className="visually-hidden">
                                password
                            </label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                className='textInput'
                                placeholder='password'
                                aria-label="password"
                                {...register('password', {
                                    required: {
                                        value: true,
                                        message: 'Password is required'
                                    },
                                    minLength: {
                                        value: 8,
                                        message: "Password should be at least 8 characters long"
                                    },
                                    pattern: {
                                        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
                                        message: 'Password must include at least one uppercase letter, one lowercase letter, one number, and one special character'
                                    }
                                })}
                                style={{ width: '100%', paddingRight: '2.5rem' }}
                            />
                            {pswd.length > 0 && (
                                <div className='input-group-append'>
                                    <IconContext.Provider value={{ size: '1.5em' }}>
                                        <span className='input-group-text' onClick={togglePasswordVisibility} style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: '10px',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            backgroundColor: 'transparent',
                                            border: 'none'
                                        }}>
                                            {!showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                                        </span>
                                    </IconContext.Provider>
                                </div>
                            )}
                        </div>
                        <div className="error-msg">{errors.password?.message}</div>

                        <div className='inputWrapper'>
                            <label className="visually-hidden">
                                School Name
                            </label>
                            <input
                                type='text'
                                className='textInput'
                                placeholder='School Name'
                                aria-label="School Name"
                                {...register('schoolName', {
                                    required: {
                                        value: true,
                                        message: 'School name is required.'
                                    },
                                    maxLength: {
                                        value: 100,
                                        message: "Please enter a school name with no more than 100 characters."
                                    }
                                })}
                            />
                        </div>
                        <div className="error-msg">{errors.schoolName?.message}</div>


                        <div className='domainGroup'>
                            <div className='inputWrapper input-width-67'>
                                <label className="visually-hidden">
                                    School Domain
                                </label>
                                    <input
                                        type='text'
                                        className='textInput'
                                        placeholder='School Domain'
                                        aria-label="School Domain"
                                        {...register('schoolDomain', {
                                            required: {
                                                value: true,
                                                message: 'School domain is required.'
                                            }
                                        })}
                                    />
                            </div>
                            <div className='inputWrapper'>
                                <input
                                    type='text'
                                    className='textInput domain'
                                    placeholder={global_var.domain}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="error-msg">{errors.schoolDomain?.message}</div>

                        <div className='contactGroup'>

                            <div className='inputWrapper'>
                                <label className="visually-hidden">
                                    Contact Number
                                </label>

                                    <PhoneInput
                                        placeholder={'Enter Number'}
                                        value={
                                            `+${mobileNumber.dialCode}${mobileNumber.number}`
                                        }
                                        containerClass={"mb-md-3 mb-2 rounded-1 border-0 input-height "}
                                        inputStyle={{ width: '100%', height: '50px', boxShadow: '0 0 0 .07rem #dadade', paddingLeft: '70px', border: 'none',borderRadius:"10px" }}
                                        inputProps={{
                                            name: 'mobile',
                                            autoFocus: false,
                                        }}
                                        onChange={(value, data) => handleMobileInput(value, data)}
                                    />
                            </div>

                            {/* <button type="button" className='verifyButton'>Verify</button> */}
                        </div>
                        <div className="error-msg">{errors.contactNumber?.message}</div>

                        <div className='locationFields'>
                            <div className='inputWrapper input-width-53'>
                                <label className="visually-hidden">
                                    Country
                                </label>
                                <select
                                    className='custom-select'
                                    aria-label="Country"
                                    {...register("country", {
                                        required: {
                                            value: true,
                                            message: "Country is required.",
                                        },
                                        onChange: (e) => fetchCountryStateDistrict({"type":"state","countryId":e.target.value})
                                    })}
                                    style={{color:"grey"}}
                                >
                                    <option value="" disabled selected>Country</option>
                                    {Countries.map((val) => (
                                        <option key={val._id} value={val._id}>{val.countryName}</option>
                                    ))}
                                </select>
                            </div>

                            <div className='inputWrapper input-width-53'>
                                <label className="visually-hidden">
                                State
                                </label>

                                <select
                                    className='custom-select'
                                    aria-label="State"
                                    {...register("state", {
                                        required: {
                                            value: false,
                                            message: "State is required.",
                                        },
                                        onChange: (e) => fetchCountryStateDistrict({"type":"district","stateId":e.target.value,"countryId":countryId})
                                    })}
                                    style={{color:"grey"}}
                                >
                                    <option value="" disabled selected>State</option>
                                    {states.map((val) => (
                                        <option key={val._id} value={val._id}>{val.stateName}</option>
                                    ))}
                                </select>
                            </div>

                        </div>
                        <div className="error-msg">{errors.country?.message}</div>

                        <div className='locationFields' style={{marginBottom: "10px"}}>
                            <div className='inputWrapper input-width-53'>
                                <label className="visually-hidden">
                                    District
                                </label>

                                <select
                                    className='custom-select'
                                    aria-label="District"
                                    {...register("district", {
                                        required: {
                                            value: false,
                                            message: "District is required.",
                                        },
                                    })}
                                    style={{color:"grey"}}
                                >
                                    <option value="" disabled selected>District</option>
                                    {district.map((val) => (
                                        <option key={val._id} value={val._id}>{val.districtName}</option>
                                    ))}
                                </select>

                            </div>

                            <div className='inputWrapper input-width-53'>
                                <label className="visually-hidden">
                                    Postal code
                                </label>
                                    <input
                                        type='text'
                                        className='textInput'
                                        placeholder='Postal code'
                                        aria-label="Postal code"
                                        {...register("postalcode", {
                                            valueAsNumber: {
                                                value: false,
                                                message: "Please enter a valid postal code.",
                                            },
                                        })}
                                    />
                            </div>

                        </div>
                        {!signupStart? (
                            <button type="submit" className='submitButton'>Sign Up</button>
                        ):(
                            <button type="submit" className='submitButton' disabled>Sign Up <Spin style={{marginLeft:'10px'}} className="white-spinner" size="small" /></button>
                        )}

                        <div className='divider'>
                            <span className='dividerLine' />
                            <span className='dividerText'>or</span>
                            <span className='dividerLine' />
                        </div>

                        {/* <button type="button" className='googleButton' onClick={handleGoogleSign}>
                            <span>Continue Sign up with Google</span>
                            <img 
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/a5cbbfd7d8e302674c117ea368a9fc98bc16927ac206e3eae2f1efd432d849a9?placeholderIfAbsent=true&apiKey=1cb9a3be957e4deda23fe6ae099807a0" 
                            alt="Google logo" 
                            className='googleIcon'
                            />
                        </button> */}

                        <p className='loginPrompt'>
                            Already have an account?{' '}
                            <a href="/login" className='loginLink'>Sign in</a>
                        </p>
                    </form>
                
                </div>
            </div>
        </div>
    )
}

export default ExternalCompanyRegistration;